import { render } from "./FormSetting.vue?vue&type=template&id=1b538994"
import script from "./FormSetting.vue?vue&type=script&lang=js"
export * from "./FormSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__